import React from 'react'
import { CaretUpOutlined } from '@ant-design/icons'
import { CollapseProps } from 'antd'

export const ExpandIcon: CollapseProps['expandIcon'] = ({ isActive }) => (
  <CaretUpOutlined rotate={isActive ? 180 : 0} style={{ color: 'gray' }} />
)
